var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["OTHER"] = 0] = "OTHER";
    DeviceType[DeviceType["MAC"] = 1] = "MAC";
    DeviceType[DeviceType["IOS"] = 2] = "IOS";
    DeviceType[DeviceType["WINDOWS"] = 3] = "WINDOWS";
    DeviceType[DeviceType["ANDROID"] = 4] = "ANDROID";
})(DeviceType || (DeviceType = {}));
export const DEVICE_INFO_VERSION = '2.0.0';
export const getDeviceInfo = (deviceType) => {
    switch (deviceType) {
        case DeviceType.MAC: {
            return { deviceName: 'macOS', deviceType };
        }
        case DeviceType.WINDOWS: {
            return { deviceName: 'Windows', deviceType };
        }
        default: {
            return { deviceName: 'Other', deviceType };
        }
    }
};
export const getDeviceType = () => {
    if (typeof navigator === 'undefined')
        return DeviceType.OTHER;
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent))
        return DeviceType.OTHER;
    const agent = navigator.userAgent.toLowerCase();
    const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (isMac) {
        return DeviceType.MAC;
    }
    if (agent.indexOf('win') >= 0 || agent.indexOf('wow') >= 0) {
        return DeviceType.WINDOWS;
    }
    return DeviceType.OTHER;
};
export const getExtraData = () => __awaiter(void 0, void 0, void 0, function* () {
    const deviceInfo = getDeviceInfo(getDeviceType());
    return JSON.stringify({
        transactionTime: Date.now(),
        deviceInfo: JSON.stringify(deviceInfo),
        version: DEVICE_INFO_VERSION,
    });
});
